import React from "react";
import PropTypes from "prop-types";
import Navigation from "../../utils/Navigation";
import TimeFormatter from "../../utils/TimeFormatter";
import { generateSmallThumbnailUrl } from "../../utils/ImageUtils";

function ShowVideo(props) {
    const { url, headline, video, onClick } = props;
    const thumbnailUrl = video.thumbnail && video.thumbnail.url;
    const formattedDuration = video.duration
        ? TimeFormatter.getPaddedDurationFromMilliSeconds(video.duration)
        : null;

    return (
        <a
            className="show-video"
            href={Navigation.stripDomainFromUrl(url)}
            onClick={onClick}
        >
            {thumbnailUrl && (
                <div className="show-video__thumbnail-container">
                    {thumbnailUrl && (
                        <img
                            className="show-video__thumbnail"
                            loading="lazy"
                            src={generateSmallThumbnailUrl(
                                thumbnailUrl,
                                254,
                                143
                            )}
                            alt=""
                        />
                    )}
                    {formattedDuration && (
                        <span className="show-video__duration">
                            {formattedDuration}
                        </span>
                    )}
                </div>
            )}
            <h3
                className="show-video__headline"
                dangerouslySetInnerHTML={{ __html: headline.html }}
            />
        </a>
    );
}

ShowVideo.defaultProps = {
    onClick: () => {},
};

ShowVideo.propTypes = {
    url: PropTypes.string.isRequired,
    headline: PropTypes.shape({
        html: PropTypes.string.isRequired,
    }).isRequired,
    video: PropTypes.shape({
        duration: PropTypes.number,
        thumbnail: PropTypes.shape({
            url: PropTypes.string.isRequired,
        }),
    }).isRequired,
    onClick: PropTypes.func,
};

export default ShowVideo;
